"use client";

import React from "react";
import Image from "../../assets/images/Cactus.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'; 

export function Trust() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#FFFFFF]">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20 ">
          <div >
          <p className="mb-3 font-semibold md:mb-4">Vertrauen</p>

            <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[40px] lg:text-[40px] max-w-[500px]">
            Warum Unternehmen uns vertrauen            </h1>
           
            <div className="grid grid-cols-1 gap-5 py-2 sm:grid-cols-1 ">
            <div className="flex flex-row">
                <div className="mb-3 md:mb-4">
                   <FontAwesomeIcon icon={faCircleCheck} className="text-green-700 w-10 h-12" /> 
                </div>
                <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Führender Anbieter im Bereich Cybersicherheit               </h6>
                <p className="max-w-[500px]">
                Maßgeschneiderte Lösungen für Unternehmen aller Größen.                </p>
                </div>
          
              </div>
              <div className="flex flex-row">
                <div className="mb-3 md:mb-4">
                   <FontAwesomeIcon icon={faCircleCheck} className="text-green-700 w-10 h-12" /> 
                </div>
                <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Erfahrung aus der Industrie                </h6>
                <p className="max-w-[500px]">
                Unser Team bringt jahrzehntelange Erfahrung aus führenden Sicherheitsunternehmen mit.                </p>
                </div>
          
              </div>
              <div className="flex flex-row">
                <div className="mb-3 md:mb-4">
                   <FontAwesomeIcon icon={faCircleCheck} className="text-green-700 w-10 h-12" /> 
                </div>
                <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Ganzheitlicher Schutz             </h6>
                <p className="max-w-[500px]">
                Wir kombinieren modernste Technologien mit bewährten Strategien für maximale Sicherheit.              </p>
                </div>
          
              </div>
             
            </div>
          </div>
          <div>
            <img
              src = {Image} 
              className="w-full object-cover h-[600px] rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

